// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
export default {
    headingBlack1: "Agentic",
    headingBlack1Visibility: true,
    headingBlack2: "that run work end to end",
    headingBlack2Visibility: true,
    headingGradient: " workflows ",
    hideComponent: true,
    mainImage: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6989ad2a057d16cc18c2a792_workflows-image.avif",
        alt: ""
    },
    sectionSubtitle: "Visually build, automate, and manage complex cross-functional processes with AI.",
    workflowsLogo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6988ce8cc1b394830bc12508_monday%20workflows%20logo.svg",
        alt: ""
    }
};
